import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, FormCheckBox, FormCardGroup } from '../Helpers/Form';
import * as Actions from '../../actions/actions';

const Searchfilter = props => {
  const {
    searchVm: { filterValues },
    searchQueryChange, errorVm: { errorMessage, success }
  } = props;

  return (
    <Form
      errorMessage={errorMessage}
      success={success}
      onChange={({ name, value }) => {
        searchQueryChange(name, value);
      }}
    >
      <FormCardGroup type="card" >
        <FormCheckBox name="filterValues" text="Umkreis 5km" value="5km" checked={filterValues.has('5km')} />
        <FormCheckBox name="filterValues" text="Umkreis 10km" value="10km" checked={filterValues.has('10km')} />
        <FormCheckBox name="filterValues" text="Umkreis 25km" value="25km" checked={filterValues.has('25km')} />
        <FormCheckBox name="filterValues" text="Umkreis 50km" value="50km" checked={filterValues.has('50km')} />
        <FormCheckBox name="filterValues" text="Männlich" value="male" checked={filterValues.has('male')} />
        <FormCheckBox name="filterValues" text="Weiblich" value="female" checked={filterValues.has('female')} />
        <FormCheckBox name="filterValues" text="Hat Profilbild" value="hasImage" checked={filterValues.has('hasImage')} />
        <FormCheckBox name="filterValues" text="Stadt" value="city" checked={filterValues.has('city')} />
        <FormCheckBox name="filterValues" text="Land" value="landscape" checked={filterValues.has('landscape')} />
        <FormCheckBox name="filterValues" text="Wohnung" value="apartement" checked={filterValues.has('apartement')} />
        <FormCheckBox name="filterValues" text="Haus" value="house" checked={filterValues.has('house')} />
      </FormCardGroup>
    </Form >
  );
};

export default connect(
  state => ({ ...state.searchReducer, ...state.petReducer, ...state.alertReducer }),
  dispatch => bindActionCreators(Actions, dispatch)
)(Searchfilter);




// WEBPACK FOOTER //
// ./src/pages/Search/Searchfilter.js